import React, { useEffect } from "react"

export default function TripAdvisorWidget() {
  useEffect(() => {
    const script = document.createElement("script")
    script.src =
      "https://www.jscache.com/wejs?wtype=certificateOfExcellence&uniq=161&locationId=10477316&lang=es&year=2025&display_version=2"
    script.async = true
    script.setAttribute("data-loadtrk", "true")

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <div
      id="TA_certificateOfExcellence161"
      className="TA_certificateOfExcellence"
    >
      <ul id="nOQHKJS" className="TA_links uEmfO7n">
        <li id="8b4AcFf" className="ryWCO3GEBuU">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.tripadvisor.es/Restaurant_Review-g642211-d10477316-Reviews-Perla_Kitchen_Bar-Mahon_Menorca_Balearic_Islands.html"
          >
            <img
              src="https://static.tacdn.com/img2/travelers_choice/widgets/tchotel_2025_LL.png"
              alt="TripAdvisor"
              className="widCOEImg"
              id="CDSWIDCOELOGO"
            />
          </a>
        </li>
      </ul>
    </div>
  )
}
